import { SharedState } from "../SharedProvider";

export const selectIsCleaningActionEnabled = (state: SharedState) => state.status.isCleaningActionEnabled;
export const selectCurrentRobotState = (state: SharedState) => state.status.currentRobotState;
export const selectCurrentRobotStateStatusRoomId = (state: SharedState) =>
  state.status.currentRobotState?.status?.roomId ?? null;
export const selectCurrentRobotPosition = (state: SharedState) => state.status.currentRobotState?.position ?? null;
export const selectCurrentRobotCoverageMap = (state: SharedState) => state.status.currentRobotState?.coverageMap ?? null;
